import { render, staticRenderFns } from "./QuestionPdfUpload.vue?vue&type=template&id=5c2e6ef2&"
import script from "./QuestionPdfUpload.vue?vue&type=script&lang=ts&"
export * from "./QuestionPdfUpload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports